/**
 * @generated SignedSource<<120b3d4d332d5748143d9d798cc423de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedStorytellingMainMedia_storyTellingTab$data = {
  readonly tabTitle: string;
  readonly mainImage: string | null;
  readonly mainVideo: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedStorytellingShopAllLink_storyTellingTab">;
  readonly " $fragmentType": "PdpSharedStorytellingMainMedia_storyTellingTab";
};
export type PdpSharedStorytellingMainMedia_storyTellingTab$key = {
  readonly " $data"?: PdpSharedStorytellingMainMedia_storyTellingTab$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedStorytellingMainMedia_storyTellingTab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedStorytellingMainMedia_storyTellingTab",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mainVideo",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedStorytellingShopAllLink_storyTellingTab"
    }
  ],
  "type": "StoryTellingTab",
  "abstractKey": null
};

(node as any).hash = "c2d4d80bbdd52e455ff60eed4d66d37d";

export default node;
